import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import DoneAllSharpIcon from '@material-ui/icons/DoneAllSharp';
import ArrowBackOutlinedIcon from '@material-ui/icons/ArrowBackOutlined';
import ArrowForwardOutlinedIcon from '@material-ui/icons/ArrowForwardOutlined';

import Spinner from '../../../spinner/spinner';
export default class TemplatesCall extends Component{
    constructor(props){
        super(props);
        this.state = {
           
        }
    }

    componentWillMount = () => {
        if(this.props.templateId){
            
        }
    }

    handleCreateTemplate = () => {
       
    }

    render(){
        return (
            <>
                <div className="email-template-wrap">
                    <div className='rightSectionHeader'>
                        <div className="row justify-content-between align-items-center">
                            <div className="col-md-6 tab-right-header">
                                <h6>Call Template</h6>
                                <p>Create call template</p>
                            </div>
                            <div className="col-md-6 text-right">
                                <Button variant="success" type="button" onClick={this.handleCreateTemplate}><DoneAllSharpIcon className="btn-icon"></DoneAllSharpIcon> Save </Button>
                            </div>
                        </div>
                    </div>
                    <div className="py-2">
                        Discuss for template data
                    </div>
                </div>
                <div className="mt-2">
                    <div className='footer-wrapper justify-content-end d-flex'>
                        <Button variant="secondary" className="mr-2" onClick={e => this.props.handleTabChange('prev')}><ArrowBackOutlinedIcon className="btn-icon"></ArrowBackOutlinedIcon> Previous</Button>
                        <Button variant="success" type="button" onClick={e => this.props.handleTabChange('next')}><Spinner loading={this.state.loading}></Spinner><ArrowForwardOutlinedIcon className={this.state.loading?"btn-icon d-none": "btn-icon"}></ArrowForwardOutlinedIcon> Go To Next</Button>
                    </div>
                </div>
            </>
        )
    }
}
